//const baseUrl = 'http://alpha-03.trizentinc.com:40080/empats/uat';
// const baseUrl = 'https://alpha-03.trizentinc.com/empats/uat';
const baseUrl =
  (window as any)?.API_BASE_URL ||
  `https://api.empats-uat.alpha-03.trizentinc.com`;

export default baseUrl;
